export function decodeShopifyId(
  input: null | string | undefined
): null | string | undefined {
  if (input == null || input === "") return input

  // Already decoded? (Most Shopify GIDs start with "gid://")
  if (input.startsWith("gid://")) return input

  // Normalize URL-safe alphabet and add padding
  let b64 = input.replace(/-/g, "+").replace(/_/g, "/")
  const pad = b64.length % 4
  if (pad) b64 = b64 + "=".repeat(4 - pad)

  // Try browser fast path (atob). These GIDs are ASCII, so Unicode isn’t an issue.
  try {
    if (typeof atob === "function") {
      // atob may throw on malformed input
      const str = atob(b64)
      return str.startsWith("gid://") ? str : input
    }
  } catch {
    // no-op
  }

  // Try Node/SSR path (Buffer)
  try {
    // In browsers without a Buffer polyfill, this will throw — that’s fine.
    const out =
      typeof Buffer !== "undefined"
        ? Buffer.from(b64, "base64").toString("utf8")
        : input
    return out.startsWith("gid://") ? out : input
  } catch {
    return input
  }
}

// Extracts the numeric ID from a Shopify GID or base64-encoded GID
export function getNumericIdFromGid(
  gidOrBase64: null | string | undefined
): null | string {
  const decoded = decodeShopifyId(gidOrBase64 ?? "")
  if (!decoded) return null
  const parts = parseGidUrl(decoded)
  return parts?.id ?? null
}

// Extracts pieces from a decoded Shopify GID like "gid://shopify/Product/8100847845464"
export function parseGidUrl(gid: string) {
  const m = /^gid:\/\/([^/]+)\/([^/]+)\/(.+)$/.exec(gid)
  return m ? { id: m[3], namespace: m[1], resource: m[2] } : null
}
